import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'

@Component
export default class CustomFooter extends Vue {
    public qrcodes = []
    @Prop() private msg!: ''
}